const urlName = '/train/v1'
export default API => ({
    // 列表
    findByCondition(data,pageNum,pageSize) {
        return API({
            url: `${urlName}/train/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data
        });
    },
    // 保存
    trainSave(data) {
        return API({
            url: `${urlName}/train/save` ,
            method:  'post',
            data
        });
    },
    // 详情
    findById(id) {
        return API({
            url: `${urlName}/train/findById?id=${id}`});
    },
    // 列表发布
    publish(data) {
        return API({
            url: `${urlName}/train/publish?id=${data}` ,
            method:  'post',
        });
    },
    // 删除
    deldata(data) {
        return API({
            url: `${urlName}/train/delete?id=${data}` ,
            method:  'post',
        });
    },
    // 撤回
    unPublish(data) {
        return API({
            url: `${urlName}/train/unPublish?id=${data}` ,
            method:  'post',
        });
    },
    // 统计
    getStatisticInfo(trainId) {
        return API({
            url: `${urlName}/train/getStatisticInfo?trainId=${trainId}` ,
            method:  'get',
        });
    },
    // 统计学习进度列表
    findUserStudyBasicInfoList(trainId,pageNum,pageSize) {
        return API({
            url: `${urlName}/train/findUserStudyBasicInfoList?trainId=${trainId}&pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'get',
        });
    },
    // 统计详情学习进度列表
    findUserStudyDetailInfo(id) {
        return API({
            url: `${urlName}/train/findUserStudyDetailInfo?id=${id}` ,
            method:  'get',
        });
    },
    // 已经指派(指派)
    findByConditionTrainUser(data,pageNum,pageSize) {
        return API({
            url: `${urlName}/trainUser/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data
        });
    },
    // 学员列表
    findOrganUserByCondition(data,pageNum,pageSize) {
        return API({
            url: `${urlName}/trainUser/findOrganUserByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
            method:  'post',
            data
        });
    },
    //删除
    deleteUser(idList) {
        return API({
            url: `${urlName}/trainUser/delete?idList=${idList}` ,
            method:  'get',
        });
    },
    addUser(data){
        return API({
            url: `${urlName}/trainUser/add` ,
            method:  'post',
            data
        });
    },
    // 获取考试名称列表
    getTestNameList(trainId){
        return API({
            url: `${urlName}/trainItem/findTrainExamByTrainid?trainId=${trainId}` ,
            method:  'post',
        });
    },
    // 查询训练营用户统计分析
    getUserAnalysis(contentId,trainId) {
        return API({
            url: `${urlName}/trainItemExam/getUserPaperInfo?contentId=${contentId}&trainId=${trainId}` ,
            method:  'get',
        });
    },
    // 查询训练营用户列表
    findTrainUserExamWithPage(contentId,pageNum,pageSize,trainId) {
        return API({
            url: `${urlName}/trainItemExam/findTrainUserExamWithPage?contentId=${contentId}&pageNum=${pageNum}&pageSize=${pageSize}&trainId=${trainId}` ,
            method:  'get',
        });
    },
    // 下载成绩接口
    exportExamInfoList(contentId,trainId,idList) {
        return API({
            url: `${urlName}/trainItemExam/exportExamInfoList?contentId=${contentId}&trainId=${trainId}&idList=${idList}` ,
            method:  'get',
        });
    },
    // 查询训练营用户详细考试信息表头分析
    findScoreByUser(contentId,trainId,userId) {
        return API({
            url: `${urlName}/trainItemExam/findScoreByUser?contentId=${contentId}&trainId=${trainId}&userId=${userId}` ,
            method:  'get',
        });
    },
    // 查询训练营用户详细考试信息列表
    findScoreListByUser(contentId,pageNum,pageSize,trainId,userId) {
        return API({
            url: `${urlName}/trainItemExam/findScoreListByUser?contentId=${contentId}&pageNum=${pageNum}&pageSize=${pageSize}&trainId=${trainId}&userId=${userId}` ,
            method:  'get',
        });
    },
    // 证书管理：保存
    saveTrainCertificate(data) {
        return API({
            url: `${urlName}/trainCertificate/save`,
            method: 'post',
            data
        })
    },
    // 证书管理： 修改
    updateByTrainId(data) {
        return API({
            url: `${urlName}/trainCertificate/updateByTrainId`,
            method: 'post',
            data
        })
    },
    // 获取训练营证书的信息
    getTrainCertificateInfo(id) {
        return API({
            url: `${urlName}/trainCertificate/findTrainCertById?id=${id}`,
            method: 'get'
        })
    },
})
